'use client';

import JsonLd from "@/components/seo/JsonLd";
export interface BreadcrumbItem { name: string; item?: string; }

import { usePathname } from 'next/navigation';

export default function BreadcrumbJsonLd({ customItems }: { customItems?: BreadcrumbItem[] }) {
  const pathname = usePathname();
  if (!pathname) return null;

  // Split path segments
  const segments = pathname.split('/').filter(Boolean);

  // If we are on home page, no breadcrumbs are needed (or it's just home)
  if (segments.length === 0) return null;

  const isLocalized = segments[0]?.toLowerCase() === 'en' || segments[0]?.toLowerCase() === 'fr';
  const targetSegment = (isLocalized ? segments[1] : segments[0])?.toLowerCase();

  if (!targetSegment) return null; // e.g. /en or /fr

  const isExcluded = 
    targetSegment === 'admin' ||
    targetSegment === 'dashboard' ||
    targetSegment === 'login' ||
    targetSegment === 'register' ||
    targetSegment === 'help' ||
    targetSegment === 'compare' ||
    (targetSegment === 'insights' && segments.length > (isLocalized ? 2 : 1)) ||
    targetSegment.startsWith('ai-for-') ||
    ['legal', 'real-estate', 'finance', 'education'].includes(targetSegment);

  if (isExcluded) return null;

  // Generate breadcrumb items
  const items = [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://www.guidetoreviews.com"
    }
  ];

  let currentPath = 'https://www.guidetoreviews.com';
  segments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    
    // Capitalize and clean name
    const name = segment
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());

    items.push({
      "@type": "ListItem",
      "position": index + 2,
      "name": name,
      "item": currentPath
    });
  });

  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
